import React, {Component} from 'react';


class FooterBlock extends Component{
    render(){
        return(
            <div className="footer-block">Designed by <a href="http://creatovia.com" rel="noopener noreferrer" target="_blank">Creatovia</a></div>
        )
    }
}

export default FooterBlock;